import {Task} from './Task.js';
import {getFontFamilies} from './DOM.js';
import {union} from './utils.js';
import {log, warn} from './logfunctions.js';
import {FontWatcher} from './FontWatcher.js';
import {COMPLETE} from './constants.js';

/**
 * Dispatches a COMPLETE when the specified fonts have all either loaded or failed to load. To
 * specify the fonts to wait for, pass the constructor either one or both of a StyleSheet object
 * containing @font-face rules or a Set of font family names.
 */
export class AwaitFontsTask extends Task {

  /**
   * @param styleSheet  A StyleSheet object containing @font-face rules.
   * @param fontFamilies  A Set of font family names (e.g., "Times New Roman").
   */
  constructor (styleSheet, fontFamilies = new Set()) {
    super();
    this.name = 'AWAIT_FONTS_TASK';
    this.styleSheet = styleSheet;
    this.fontFamilies = fontFamilies;
  }

  /**
   * Waits for all fonts to either load or fail to load, then dispatches COMPLETE.
   */
  start () {
    super.start();
    let allFontFamilies = union(getFontFamilies(this.styleSheet), this.fontFamilies);

    if (allFontFamilies.size > 0) {
      log('Queuing fonts: ' + [...allFontFamilies].join(', '));
      let fontLoader = new FontWatcher();
      fontLoader.on(COMPLETE, e => {
        this.done();
      });
      fontLoader.watchFonts(allFontFamilies);
    } else {
      warn(`[${this.name}] No fonts found. Ending task.`);
      this.done();
    }
  }
}
